"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useResizeObserver = void 0;
var react_1 = require("react");
var resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));
var defaultCallback = function (entry) {
    return entry;
};
/**
 * Hook for observing changes to a DOM element via ResizeObserver.
 *
 * @param {resolveEntryCallback} resolveEntry - Callback for resolving the
 * desired value from each ResizeObserverEntry emitted by ResizeObserver
 * @return {Array} An array containing a ref for binding to the observed DOM
 * element, and the current value of the callback-resolved ResizeObserverEntry
 * @callback resolveEntryCallback
 */
var useResizeObserver = function (resolveEntry) {
    if (resolveEntry === void 0) { resolveEntry = defaultCallback; }
    var destroyResizeObserverRef = (0, react_1.useRef)(undefined);
    var _a = (0, react_1.useState)(undefined), dimensions = _a[0], setDimensions = _a[1];
    var resolveEntryRef = (0, react_1.useRef)(resolveEntry);
    var ref = (0, react_1.useCallback)(function (node) {
        if (node) {
            var resizeObserver_1 = new resize_observer_polyfill_1["default"](function (entries) {
                for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                    var entry = entries_1[_i];
                    var value = resolveEntryRef.current(entry);
                    if (value) {
                        setDimensions(value);
                    }
                }
            });
            resizeObserver_1.observe(node);
            destroyResizeObserverRef.current = function () {
                resizeObserver_1.disconnect();
            };
        }
    }, [destroyResizeObserverRef, setDimensions, resolveEntryRef]);
    // Ensure the resolveEntryRef has the latest value
    (0, react_1.useEffect)(function () {
        resolveEntryRef.current = resolveEntry;
    }, [resolveEntry]);
    // Destroy the observer on unmount
    (0, react_1.useEffect)(function () { return function () {
        if (destroyResizeObserverRef.current) {
            destroyResizeObserverRef.current();
        }
    }; }, []);
    return [ref, dimensions];
};
exports.useResizeObserver = useResizeObserver;
//# sourceMappingURL=useResizeObserver.js.map